import { ValidationModel, ValidationType } from "@/services/validation/types";

export const detailsValidators = {
    firstName: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Min, value: 3 }
        ]
    } as ValidationModel,
    lastName: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Min, value: 3 }
        ]
    } as ValidationModel,
    roles: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Number },
            { type: ValidationType.Min, value: 1 }
        ]
    } as ValidationModel,
    email: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Min, value: 3 },
            { type: ValidationType.UniqueEmail }
        ]
    } as ValidationModel,
    password: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Min, value: 3 }
        ]
    } as ValidationModel,
    repeatPassword: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Min, value: 3 },
            { type: ValidationType.Confirm }
        ]
    },
    name: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Min, value: 3 }
        ]
    } as ValidationModel,
    description: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Min, value: 3 }
        ]
    } as ValidationModel
};
